import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class CompanyService {
    static getCompanies(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`companies?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.company.createdOn = parseDate(x.company.createdOn);
                x.company.updatedOn = parseDate(x.company.updatedOn);
            });
            return w;
        }));
    }
    static fetchCompany(oid) {
        return BaseService.get(`companies/${oid}`).pipe(map(x => {
            x.payload.createdOn = parseDate(x.payload.createdOn);
            x.payload.updatedOn = parseDate(x.payload.updatedOn);
            return x;
        }));
    }
    static fetchCompanyData(oid) {
        return BaseService.get(`companies-data/${oid}`).pipe(map(x => {
            x.payload.createdOn = parseDate(x.payload.createdOn);
            x.payload.updatedOn = parseDate(x.payload.updatedOn);
            x.payload.dataFondoDip = parseDate(x.payload.dataFondoDip);
            x.payload.dataFondoDir = parseDate(x.payload.dataFondoDir);
            return x;
        }));
    }
    static saveCompany(dto) {
        return BaseService.save(`companies`, dto);
    }
    static saveCompanyData(dto) {
        return BaseService.save(`companies-data`, dto);
    }
    static deleteCompany(oid) {
        return BaseService.delete(`companies/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Comments
    // ----------------------------------------------------------------------
    static getCompanyComments(companyId) {
        return BaseService.get(`company-comments/${companyId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveCompanyComment(dto) {
        return BaseService.post(`company-comments`, dto);
    }
    static deleteCompanyComment(oid) {
        return BaseService.delete(`company-comments/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Channels
    // ----------------------------------------------------------------------
    static getCompanyChannels(companyId) {
        return BaseService.get(`company-channels/${companyId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveCompanyChannel(dto) {
        return BaseService.post(`company-channels`, dto);
    }
    static deleteCompanyChannel(oid) {
        return BaseService.delete(`company-channels/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Contacts
    // ----------------------------------------------------------------------
    static getCompanyContacts(companyId) {
        return BaseService.get(`company-contacts/${companyId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveCompanyContact(dto) {
        return BaseService.save(`company-contacts`, dto);
    }
    static deleteCompanyContact(oid) {
        return BaseService.delete(`company-contacts/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Ownership
    // ----------------------------------------------------------------------
    static getCompanyOwnership(companyId) {
        return BaseService.get(`company-ownership/${companyId}`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
    }
    static saveCompanyOwnership(dto) {
        return BaseService.save(`company-ownership`, dto);
    }
    static deleteCompanyOwnership(oid) {
        return BaseService.delete(`company-ownership/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchCompanyCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`companies-combo/${selfId}?search=${qs}`);
    }
}
